let notificationCount = 0;
const newAssignmentIds = new Set();
const unseenAssignmentIds = new Set();

export const currentState = () => ({
    notificationCount,
    assignmentIds: Array.from(newAssignmentIds),
    unseenAssignmentIds: Array.from(unseenAssignmentIds)
});

export const getNotificationCount = () => notificationCount;

export const newAssignmentCount = () => newAssignmentIds.size;

export const incrementNotificationCount = (count = 1) => {
    notificationCount += count;
};

export const setNotificationCount = (count) => {
    notificationCount = count;
};

export const clearNotificationCount = () => {
    notificationCount = 0;
};

export const trackAssignmentIds = (assignmentIds = []) => {
    const trackedAssignmentIds = [];

    assignmentIds.forEach((assignmentId) => {
        if (assignmentId != null && assignmentId !== '') {
            const normalizedAssignmentId = String(assignmentId);
            const alreadyTracked = newAssignmentIds.has(normalizedAssignmentId);

            newAssignmentIds.add(normalizedAssignmentId);
            unseenAssignmentIds.add(normalizedAssignmentId);

            if (!alreadyTracked) {
                trackedAssignmentIds.push(normalizedAssignmentId);
            }
        }
    });

    return trackedAssignmentIds;
};

export const hasNewAssignment = (assignmentId) => newAssignmentIds.has(String(assignmentId));

export const hasUnseenAssignment = (assignmentId) => unseenAssignmentIds.has(String(assignmentId));

export const unseenAssignmentCount = () => unseenAssignmentIds.size;

export const clearAssignment = (assignmentId) => {
    const normalizedAssignmentId = String(assignmentId);
    newAssignmentIds.delete(normalizedAssignmentId);
    unseenAssignmentIds.delete(normalizedAssignmentId);
    notificationCount = Math.min(notificationCount, newAssignmentIds.size);
};

export const clearAssignments = () => {
    newAssignmentIds.clear();
    unseenAssignmentIds.clear();
};

export const markAssignmentSeen = (assignmentId) => {
    unseenAssignmentIds.delete(String(assignmentId));
};
